window.addEventListener('load', (event) => {
    $('.header__menu-item').on('click', function () {
        var Swipes = new Swiper('.swiper-container13', {
            loop: false,
            spaceBetween: 30,    
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            slidesPerView: 'auto',
        });
    });

    $('.step_desc_box .step_description[data-descindex = "1"]').show();  
});

$('.g_steps_form_two_accordian .steps .step').on('click', function () {
    var step_index = $(this).data('stepindex');
    $(this).addClass('active').siblings().removeClass('active');
    $('.step_desc_box .step_description').each(function () {
        var step_desc = $(this).data('descindex');
        if (step_index == step_desc) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
});

$('.g_steps .g_steps_form_two_accordian .steps').on('afterChange', function (event, slick) {
    var stepIndex = $('.steps .active').data('stepindex');
    $('.g_steps .g_steps_form_two_accordian .steps .step.slick-slide.slick-current.slick-active').addClass('active');
    if (stepIndex == 1) {
        $('.menu_step ul li[data-list = "1"]').addClass('active').siblings().removeClass('active');
        $('.step_desc_box .step_description[data-descindex = "1"]').show();
        $('.step_desc_box .step_description[data-descindex = "2"]').hide();
        $('.step_desc_box .step_description[data-descindex = "3"]').hide();
        $('.step_desc_box .step_description[data-descindex = "4"]').hide();
    } else if (stepIndex == 2) {
        $('.menu_step ul li[data-list = "2"]').addClass('active').siblings().removeClass('active');
        $('.step_desc_box .step_description[data-descindex = "1"]').hide();
        $('.step_desc_box .step_description[data-descindex = "2"]').show();
        $('.step_desc_box .step_description[data-descindex = "3"]').hide();
        $('.step_desc_box .step_description[data-descindex = "4"]').hide();
    } else if (stepIndex == 3) {
        $('.menu_step ul li[data-list = "3"]').addClass('active').siblings().removeClass('active');
        $('.step_desc_box .step_description[data-descindex = "1"]').hide();
        $('.step_desc_box .step_description[data-descindex = "2"]').hide();
        $('.step_desc_box .step_description[data-descindex = "3"]').show();
        $('.step_desc_box .step_description[data-descindex = "4"]').hide();
    } else if (stepIndex == 4) {
        $('.menu_step ul li[data-list = "4"]').addClass('active').siblings().removeClass('active');
        $('.step_desc_box .step_description[data-descindex = "1"]').hide();
        $('.step_desc_box .step_description[data-descindex = "2"]').hide();
        $('.step_desc_box .step_description[data-descindex = "3"]').hide();
        $('.step_desc_box .step_description[data-descindex = "4"]').show();
    }
});

$('.scroll-up-btn-icon').on('click', function() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
})

$(".js-footer-block-btn").on("click", function(e) {
    if (window.matchMedia('(min-width: 750px)').matches) {
        return
    }
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".footer-block__details-content").hide(); // .slideUp(200);
        $(this).find('span').removeClass('button-minus-icon').addClass('button-plus-icon');
    } else {
        $(this).find('span').removeClass('button-plus-icon').addClass('button-minus-icon');
        $(this).removeClass("active");
        $(this).addClass("active");
        $(this).siblings(".footer-block__details-content").show(); // .slideDown(200);   
    }
});

$(window).on('load', function() {
    if (window.matchMedia('(min-width: 750px)').matches) {
        $('.footer-block__details-content').show()
    } else {
        $(".js-footer-block-btn").trigger('click')
    }
})

/* Product-service */
var Swipes = new Swiper('.sliders-dev12', {
    slidesPerView: 5,
    slidesPerColumn: 2,
  	slidesOffsetAfter:0,
    spaceBetween: 20,
    elementClass: 'swiper-lazy',
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    lazy: true,
    lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 16,
        loadOnTransitionStart: true,
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader'
    },
    pagination: {
        el: '.swiper-pagination',
    },
    breakpoints: {
    1700: {
        slidesPerView:4,
        slidesPerColumn:2,
        spaceBetween: 20
      },  
      1200: {
        slidesPerView:3,
        slidesPerColumn:2,
        spaceBetween: 20
      },  
      990: {
        slidesPerView: 3,
        slidesPerColumn: 1,
        spaceBetween: 30
      },
      750: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      600: {
        slidesPerView:1.5,
        slidesPerColumn: 1,
        spaceBetween: 10,
      }
    },
    
});

/* THIS IS CONTROLLING THE HIDE AND SHOW COLLECTIONS IN PRODUCT-SERVICE HEADER*/

var is_product_service_menu_show = false;
var product_service_menu_contents = ['.label-content', '.sticker-content', '.sticker-label-content', '.media-content', '.graphic-content', '.photography-content', '.decoration-content', '.stickerSticker-content']
var show_product_service_menu = function() {
    $('.body-overlay').fadeIn();
    $('.product-service-menu').fadeIn();
    $('.product-service-menu .menu').removeClass('active');
    product_service_menu_contents.forEach(function(content) {
        $('.product-service-menu .content-wrapper ' + content).hide()
    });
    $('.product-service-menu .menu').first().addClass('active');
    $('.product-service-menu .content-wrapper ' + product_service_menu_contents[0]).show();
    set_layout_content_slider();
    $(window).on('resize', set_layout_content_slider);
    is_product_service_menu_show = true
    closeModalFunction = hide_product_service_menu
};

var hide_product_service_menu = function() {
    $('.product-service-menu').fadeOut();
    $(window).off('resize', set_layout_content_slider);
    $('#product-service-menu-button').removeClass('active');
    $('#product-service-menu-button').find('i[data-name="more"]').show();
    $('#product-service-menu-button').find('i[data-name="less"]').hide();
    is_product_service_menu_show = false;
    closeModalFunction = null;
};

var set_layout_content_slider = function() {
    var width = $('.product-service-menu').width() - 350;
    $('.product-service-menu .content-wrapper .slider').width(width);
};

$(document).ready(function() {
    $('#product-service-menu-button').click(function() {
        if (is_product_service_menu_show) {
            closeOverlay();
        } else {
            show_product_service_menu();
            $(this).addClass('active');
            $(this).find('i[data-name="less"]').show();
            $(this).find('i[data-name="more"]').hide();
        }
    });
    $('.product-service-menu .menu').click(function() {
        $('.product-service-menu .menu').removeClass('active');
        product_service_menu_contents.forEach(function(content) {
            $('.product-service-menu .content-wrapper ' + content).hide()
        });
        $(this).addClass('active');
        var targetIndex = $(this).data('index');
        $('.product-service-menu .content-wrapper ' + product_service_menu_contents[targetIndex]).show();
        if (targetIndex === 0) {
            $(window).on('resize', set_layout_content_slider);
        } else {
            $(window).off('resize', set_layout_content_slider);
        }
    });
    $('.product-service-menu .content-wrapper .slider').slick({
        infinite: false,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 3,
        variableWidth: true
    });
});


/* THIS IS CONTROLLING THE HIDE AND SHOW COLLECTIONS IN PRODUCT-SERVICE SECTION*/

var windowWidth = window.width
  
var product_service_contents = [
  '.label-content',
  '.sticker-content',
  '.sticker-label-content',
  '.media-content',
  '.graphic-content',
  '.photography-content',
  '.decoration-content',
  '.stickerSticker-content'
];

var is_product_service_render = [false, false, false, false, false, false]
var init_product_service = function() {
    $('.product .menu').first().addClass('active');
    $('.product .list ' + product_service_contents[0]).addClass('sactive');
    if (windowWidth <= 600) { 
      show_product_service_mobile(0); 
    } else { 
      is_product_service_render[0] = true 
    }
    $('.product .list ' + product_service_contents[0] + ' .slider').slick({ 
      infinite: false, 
      speed: 300, 
      slidesToShow: 4, 
      slidesToScroll: 3, 
      responsive: [
        { 
          breakpoint: 1000, 
          settings: { 
            slidesToShow: 4,
            slidesToScroll: 4 
          } 
        }, 
        { 
          breakpoint: 600,
          settings: 'unslick' 
        }
      ] 
    });
    current_index_product_service = 0;
};

var show_product_service_mobile = function(index) {
    var cardList = $('.product .list ' + product_service_contents[index] + ' .card')
    $(cardList).slice(0, 4).show();
};

var render_product_list = function(index) {
    if ($(window).width() <= 600) {
        show_product_service_mobile(index);
        is_product_service_render[index] = false;
    } else {
        if (!is_product_service_render[index]) {
            $('.product .list ' + product_service_contents[index] + ' .slider').slick({ 
              infinite: false, 
              speed: 300, 
              slidesToShow: 5, 
              slidesToScroll: 4, 
              responsive: [
                { 
                  breakpoint: 600, 
                  settings: 'unslick' 
                }
              ] 
            });
            is_product_service_render[index] = true;
        }
    }
};

var current_index_product_service = 0;
$(document).ready(function() {
    init_product_service();
    $('.product .menu').click(function() {
        $('.product .menu').removeClass('active');
        product_service_contents.forEach(function(content) {
            $('.product .list ' + content).removeClass('sactive');
        });
        $(this).addClass('active');
        var targetIndex = $(this).data('index');
        current_index_product_service = targetIndex;
        $('.product .list ' + product_service_contents[targetIndex]).addClass('sactive');
        $(".sactive .slider .card:hidden").slice(0, 4).show();
        render_product_list(targetIndex);
    });
    $(window).on('resize', function() { render_product_list(current_index_product_service); });
});

/* Tabs Order Content */
//init step swiper in mobile view
var swiper = new Swiper('.stepsssss', {
    slidesPerView: 1,
    centeredSlides: true,
    grabCursor: true,
    loop: true,
    lazyLoading: true,
    navigation: {
        nextEl: '#js-next1',
        prevEl: '#js-prev1'
    },
    observer: true,
    observeParents: true,
});

//change step desc when step slide change by click on next or previous button and when user swipe step slide
swiper.on(`slideChange`, () => {
    setTimeout(function() {
        let activeSlide = getSwiperActiveIndex();
        hideMobileStep();
        showMobileStep(activeSlide);
        hideMobileStepDesc();
        showMobileStepDesc(activeSlide);

    }, 300);
})

//When enable loop in swiper setting swiper's will create duplicate slide.
//If use active index swiper will return duplicate slide index.
const getSwiperActiveIndex = () => {
    //get all step slide as array then use .length function to get size of array then -1 to get actual slide amount
    const lastIndex = document.querySelectorAll(`.stepsssss .swiper-wrapper .swiper-slide`).length - 1;

    if (swiper.activeIndex == lastIndex) { //check if slide index equal to last slide then return 1;
        return '1';
    }
    //check if slide index equal to 0 (duplicate slide when scroll back from first slide) then return '4' (actual last slide index)
    //change to '5' or more if there's change in the future for more slide; 
    if (swiper.activeIndex == 0) {
        return '4';
    }
    return swiper.activeIndex;
}

//hide step in mobile view;
const hideMobileStep = () => {
    document.querySelectorAll('.g_steps_form_two_accordian .menu_step ul li').forEach((element) => {
        element.classList.remove('active');
    })
}

//show step in mobile view according to step active slide
const showMobileStep = (activeSlide) => {
    document.querySelector(`.g_steps_form_two_accordian .menu_step ul li.m_${activeSlide}`).classList.add('active');
}

//hide all step desc in mobile view
const hideMobileStepDesc = () => {
    document.querySelectorAll('.g_steps_form_two_accordian .step_desc_box .step_description').forEach((element) => {
        element.style.display = 'none';
    });
}

//show step description in mobile view according to step active slide
const showMobileStepDesc = (activeSlide) => {
    document.querySelector(`.g_steps_form_two_accordian .step_desc_box .step_description.m_${activeSlide}`).style.display = 'block';
}
  